
export const PRIMARY_COLOR = '#004f9e'; 
export const SECONDARY_COLOR = '#FAAE39';